module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Edit " + _vm._s(_vm.storeToBeEdited.display_name || _vm.$route.params.store_id))]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('tabset', {
    staticClass: "margin-top-20"
  }, [_c('tab', {
    attrs: {
      "header": "Store Information"
    }
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "portlet light bordered"
  }, [_c('div', {
    staticClass: "portlet-body form"
  }, [_c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.updateStoreInformation()
      }
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": !_vm.$root.permissions['stores info update'] ? true : false
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeInformationError.length),
      expression: "storeInformationError.length"
    }],
    ref: "storeInformationError",
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearError('storeInformationError')
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.storeInformationError))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeToBeEdited.name),
      expression: "storeToBeEdited.name"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "id": "form_control_1"
    },
    domProps: {
      "value": (_vm.storeToBeEdited.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeToBeEdited, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_1"
    }
  }, [_vm._v("Store Name")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeToBeEdited.address_line_1),
      expression: "storeToBeEdited.address_line_1"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "id": "form_control_2",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.storeToBeEdited.address_line_1)
    },
    on: {
      "focus": function($event) {
        _vm.locationFocus(true)
      },
      "blur": function($event) {
        _vm.locationFocus(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeToBeEdited, "address_line_1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_2"
    }
  }, [_vm._v("Address Line 1")])]), _vm._v(" "), (_vm.displayLocationsDropdown) ? _c('div', {
    staticClass: "new-location-search-dropdown"
  }, [(!_vm.googleSearchResults.length) ? _c('div', [_vm._v("There are no locations that match your search.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.googleSearchResults), function(location, index) {
    return _c('div', {
      key: index,
      class: {
        'active': _vm.storeToBeEdited.address_line_1 == location.description
      },
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.selectLocation(location)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(location.description) + "\n                        ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeToBeEdited.address_line_2),
      expression: "storeToBeEdited.address_line_2"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "id": "form_control_3"
    },
    domProps: {
      "value": (_vm.storeToBeEdited.address_line_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeToBeEdited, "address_line_2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_3"
    }
  }, [_vm._v("Address Line 2")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeToBeEdited.city),
      expression: "storeToBeEdited.city"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "id": "form_control_4"
    },
    domProps: {
      "value": (_vm.storeToBeEdited.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeToBeEdited, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_4"
    }
  }, [_vm._v("Store City")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeToBeEdited.province),
      expression: "storeToBeEdited.province"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "id": "form_control_5"
    },
    domProps: {
      "value": (_vm.storeToBeEdited.province)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeToBeEdited, "province", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_5"
    }
  }, [_vm._v("Store Province")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeToBeEdited.country),
      expression: "storeToBeEdited.country"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "id": "form_control_6"
    },
    domProps: {
      "value": (_vm.storeToBeEdited.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeToBeEdited, "country", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_6"
    }
  }, [_vm._v("Store Country")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeToBeEdited.postal_code),
      expression: "storeToBeEdited.postal_code"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "id": "form_control_7"
    },
    domProps: {
      "value": (_vm.storeToBeEdited.postal_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeToBeEdited, "postal_code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_7"
    }
  }, [_vm._v("Store Postal Code")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('label', [_vm._v("Store Group:")]), _c('br'), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "size": "mini",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updateStoreGroupId
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n                    \t\t\t\t" + _vm._s(_vm.selectedGroupName || 'Select a group') + "\n                    \t\t\t\t"), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.storeGroups), function(group) {
    return _c('el-dropdown-item', {
      key: group.id,
      attrs: {
        "command": group,
        "disabled": !_vm.$root.permissions['stores info update'] ? true : false
      }
    }, [_vm._v("\n                              " + _vm._s(group.name) + "\n                            ")])
  }))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('label', [_vm._v("Store Timezone:")]), _c('br'), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select a timezone",
      "size": "mini",
      "disabled": !_vm.$root.permissions['stores info update'] ? true : false
    },
    model: {
      value: (_vm.storeToBeEdited.timezone),
      callback: function($$v) {
        _vm.$set(_vm.storeToBeEdited, "timezone", $$v)
      },
      expression: "storeToBeEdited.timezone"
    }
  }, _vm._l((_vm.timezones), function(zone, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "label": zone.label,
        "value": zone.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('label', [_vm._v("Store Currency:")]), _c('br'), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "size": "mini",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updateStoreCurrency
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.storeToBeEdited.currency || 'Select a currency') + "\n                            "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "CAD",
      "disabled": !_vm.$root.permissions['stores info update'] ? true : false
    }
  }, [_vm._v("\n                              CAD\n                            ")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "USD",
      "disabled": !_vm.$root.permissions['stores info update'] ? true : false
    }
  }, [_vm._v("\n                              USD\n                            ")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeToBeEdited.display_name),
      expression: "storeToBeEdited.display_name"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "id": "form_control_8"
    },
    domProps: {
      "value": (_vm.storeToBeEdited.display_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeToBeEdited, "display_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_8"
    }
  }, [_vm._v("Store Display Name")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeToBeEdited.internal_id),
      expression: "storeToBeEdited.internal_id"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "id": "form_control_9"
    },
    domProps: {
      "value": (_vm.storeToBeEdited.internal_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeToBeEdited, "internal_id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_9"
    }
  }, [_vm._v("Store Internal ID")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeToBeEdited.api_key),
      expression: "storeToBeEdited.api_key"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "readonly": _vm.$root.accountType === 'store_admin',
      "id": "form_control_10"
    },
    domProps: {
      "value": (_vm.storeToBeEdited.api_key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeToBeEdited, "api_key", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_10"
    }
  }, [_vm._v("External API Key (optional)")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeToBeEdited.phone),
      expression: "storeToBeEdited.phone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(###) ###-####'),
      expression: "'(###) ###-####'"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "id": "form_control_11"
    },
    domProps: {
      "value": (_vm.storeToBeEdited.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeToBeEdited, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_11"
    }
  }, [_vm._v("Store Phone Number")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeToBeEdited.fax),
      expression: "storeToBeEdited.fax"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(###) ###-####'),
      expression: "'(###) ###-####'"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "id": "form_control_12"
    },
    domProps: {
      "value": (_vm.storeToBeEdited.fax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeToBeEdited, "fax", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_12"
    }
  }, [_vm._v("Store Fax Number")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeToBeEdited.email),
      expression: "storeToBeEdited.email"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "id": "form_control_13"
    },
    domProps: {
      "value": (_vm.storeToBeEdited.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeToBeEdited, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_13"
    }
  }, [_vm._v("Store Email")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('label', [_vm._v("Store Is Corporate:")]), _c('br'), _vm._v(" "), _c('el-switch', {
    attrs: {
      "disabled": !_vm.$root.permissions['stores info update'] ? true : false,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    on: {
      "change": _vm.updateStoreIsCorporate
    },
    model: {
      value: (_vm.storeToBeEdited.is_corporate),
      callback: function($$v) {
        _vm.$set(_vm.storeToBeEdited, "is_corporate", $$v)
      },
      expression: "storeToBeEdited.is_corporate"
    }
  }), _vm._v(" "), (_vm.isCorporateUpdated) ? _c('p', [_vm._v("Corporate Store updates will take effect next time you log in.")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder clear"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit",
      "disabled": !_vm.$root.permissions['stores info update'] ? true : false
    }
  }, [_vm._v("\n                      Save\n                    ")])])])])])])])]), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Store Meta"
    }
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "portlet light bordered"
  }, [_c('div', {
    staticClass: "portlet-body form"
  }, [(!_vm.noProfileData.length) ? _c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.updateStoreMeta()
      }
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": !_vm.$root.permissions['stores meta update'] ? true : false
    }
  }, [_c('div', {
    staticClass: "form-body"
  }, [(_vm.storeMetaError.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearError('storeMetaError')
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.storeMetaError))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(" Field ")]), _vm._v(" "), _c('th', [_vm._v(" Value ")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("\n                  \t    \t\t\tOpening Soon\n                  \t    \t\t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    ref: "openingSoon",
    attrs: {
      "disabled": !_vm.$root.permissions['stores meta update'] ? true : false,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.metaToBeEdited.opening_soon),
      callback: function($$v) {
        _vm.$set(_vm.metaToBeEdited, "opening_soon", $$v)
      },
      expression: "metaToBeEdited.opening_soon"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                  \t    \t\t\tStore Has Online Ordering\n                  \t    \t\t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "disabled": _vm.metaToBeEdited.opening_soon === 1 || !_vm.$root.permissions['stores meta update'] ? true : false,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.metaToBeEdited.online_ordering),
      callback: function($$v) {
        _vm.$set(_vm.metaToBeEdited, "online_ordering", $$v)
      },
      expression: "metaToBeEdited.online_ordering"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                  \t    \t\t\tStore Has Online Ordering Enabled\n                  \t    \t\t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "disabled": _vm.metaToBeEdited.online_ordering === 0 || _vm.metaToBeEdited.opening_soon === 1 || !_vm.$root.permissions['stores meta update'] ? true : false,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.metaToBeEdited.current_online_ordering_status),
      callback: function($$v) {
        _vm.$set(_vm.metaToBeEdited, "current_online_ordering_status", $$v)
      },
      expression: "metaToBeEdited.current_online_ordering_status"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                  \t    \t\t\tStore Has Delivery\n                  \t    \t\t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    ref: "delivery",
    attrs: {
      "disabled": _vm.metaToBeEdited.opening_soon === 1 || !_vm.$root.permissions['stores meta update'] ? true : false,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.metaToBeEdited.delivery),
      callback: function($$v) {
        _vm.$set(_vm.metaToBeEdited, "delivery", $$v)
      },
      expression: "metaToBeEdited.delivery"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                  \t    \t\t\tStore Has Delivery Enabled\n                  \t    \t\t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "disabled": _vm.metaToBeEdited.delivery === 0 || _vm.metaToBeEdited.opening_soon === 1 || !_vm.$root.permissions['stores meta update'] ? true : false,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.metaToBeEdited.current_delivery_status),
      callback: function($$v) {
        _vm.$set(_vm.metaToBeEdited, "current_delivery_status", $$v)
      },
      expression: "metaToBeEdited.current_delivery_status"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n            \t            \t\tPickup Later\n            \t            \t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "disabled": !_vm.$root.permissions['stores meta update'] ? true : false,
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.metaToBeEdited.enable_pickup_later),
      callback: function($$v) {
        _vm.$set(_vm.metaToBeEdited, "enable_pickup_later", $$v)
      },
      expression: "metaToBeEdited.enable_pickup_later"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                              Catering\n                            ")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "disabled": _vm.metaToBeEdited.opening_soon === 1 || !_vm.$root.permissions['stores meta update'] ? true : false,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.metaToBeEdited.catering),
      callback: function($$v) {
        _vm.$set(_vm.metaToBeEdited, "catering", $$v)
      },
      expression: "metaToBeEdited.catering"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                  \t    \t\t\tCatering Enabled\n                  \t    \t\t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "disabled": _vm.metaToBeEdited.catering === 0 || _vm.metaToBeEdited.opening_soon === 1 || !_vm.$root.permissions['stores meta update'] ? true : false,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.metaToBeEdited.current_catering_status),
      callback: function($$v) {
        _vm.$set(_vm.metaToBeEdited, "current_catering_status", $$v)
      },
      expression: "metaToBeEdited.current_catering_status"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                  \t    \t\t\tGift Cards\n                  \t    \t\t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "disabled": _vm.metaToBeEdited.opening_soon === 1 || !_vm.$root.permissions['stores meta update'] ? true : false,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.metaToBeEdited.gift_card),
      callback: function($$v) {
        _vm.$set(_vm.metaToBeEdited, "gift_card", $$v)
      },
      expression: "metaToBeEdited.gift_card"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                  \t    \t\t\tDigital Rewards\n                  \t    \t\t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "disabled": _vm.metaToBeEdited.opening_soon === 1 || !_vm.$root.permissions['stores meta update'] ? true : false,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.metaToBeEdited.digital_reward),
      callback: function($$v) {
        _vm.$set(_vm.metaToBeEdited, "digital_reward", $$v)
      },
      expression: "metaToBeEdited.digital_reward"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                  \t    \t\t\tExternal online ordering enabled\n                  \t    \t\t")]), _vm._v(" "), _c('td', [_c('el-switch', {
    attrs: {
      "disabled": _vm.metaToBeEdited.opening_soon === 1 || !_vm.$root.permissions['stores meta update'] ? true : false,
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.metaToBeEdited.external_online_ordering_enabled),
      callback: function($$v) {
        _vm.$set(_vm.metaToBeEdited, "external_online_ordering_enabled", $$v)
      },
      expression: "metaToBeEdited.external_online_ordering_enabled"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.metaToBeEdited.external_online_ordering_enabled),
      expression: "metaToBeEdited.external_online_ordering_enabled"
    }]
  }, [_c('td', [_vm._v("\n                  \t    \t\t\tExternal order link\n                  \t    \t\t")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaToBeEdited.external_online_ordering_url),
      expression: "metaToBeEdited.external_online_ordering_url"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "disabled": _vm.metaToBeEdited.opening_soon === 1
    },
    domProps: {
      "value": (_vm.metaToBeEdited.external_online_ordering_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaToBeEdited, "external_online_ordering_url", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                  \t    \t\t\tGST Number\n                  \t    \t\t")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaToBeEdited.gst_number),
      expression: "metaToBeEdited.gst_number"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "disabled": _vm.metaToBeEdited.opening_soon === 1
    },
    domProps: {
      "value": (_vm.metaToBeEdited.gst_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaToBeEdited, "gst_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                  \t    \t\t\tPayment Processor Merchant ID (MID)\n                  \t    \t\t")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaToBeEdited.merchant_id),
      expression: "metaToBeEdited.merchant_id"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "disabled": _vm.metaToBeEdited.opening_soon === 1
    },
    domProps: {
      "value": (_vm.metaToBeEdited.merchant_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaToBeEdited, "merchant_id", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                              Payment Processor Merchant Key\n                  \t    \t\t")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaToBeEdited.merchant_key),
      expression: "metaToBeEdited.merchant_key"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "disabled": _vm.metaToBeEdited.opening_soon === 1
    },
    domProps: {
      "value": (_vm.metaToBeEdited.merchant_key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaToBeEdited, "merchant_key", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder clear"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit",
      "disabled": !_vm.$root.permissions['stores meta update'] ? true : false
    }
  }, [_vm._v("\n                        Save\n                      ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.noProfileData.length) ? _c('div', [_c('no-results', {
    attrs: {
      "show": _vm.noProfileData.length,
      "type": 'store profile',
      "custom": true,
      "text": _vm.noProfileData
    }
  })], 1) : _vm._e()])])])]), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Store Hours"
    }
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "portlet light bordered"
  }, [_c('div', {
    staticClass: "portlet-body form"
  }, [(!_vm.noHoursData.length) ? _c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.updateStoreHours()
      }
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": !_vm.$root.permissions['stores hours update'] ? true : false
    }
  }, [_c('div', {
    staticClass: "form-body"
  }, [(_vm.storeHourError.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError('storeHourError')
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.storeHourError))])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Day")]), _vm._v(" "), _c('th', [_vm._v("Opening Time")]), _vm._v(" "), _c('th', [_vm._v("Closing Time")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.hoursToBeEdited), function(hour) {
    return _c('tr', {
      key: hour.id
    }, [(hour.day === 0) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Sunday ")]) : _vm._e(), _vm._v(" "), (hour.day === 1) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Monday ")]) : _vm._e(), _vm._v(" "), (hour.day === 2) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Tuesday ")]) : _vm._e(), _vm._v(" "), (hour.day === 3) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Wednesday ")]) : _vm._e(), _vm._v(" "), (hour.day === 4) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Thursday ")]) : _vm._e(), _vm._v(" "), (hour.day === 5) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Friday ")]) : _vm._e(), _vm._v(" "), (hour.day === 6) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Saturday ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('el-time-select', {
      staticClass: "narrow-picker",
      attrs: {
        "picker-options": {
          start: '00:00',
          step: '00:15',
          end: '23:45'
        },
        "placeholder": "Opening time",
        "disabled": !_vm.$root.permissions['stores hours update'] ? true : false
      },
      model: {
        value: (hour.open_time),
        callback: function($$v) {
          _vm.$set(hour, "open_time", $$v)
        },
        expression: "hour.open_time"
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-icon-only btn-outline blue",
      attrs: {
        "data-toggle": "tooltip",
        "title": "Copy to all",
        "disabled": !_vm.$root.permissions['stores hours update'] ? true : false
      },
      on: {
        "click": function($event) {
          _vm.applyOpeningTimeToAll(hour.open_time, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-clone",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('el-time-select', {
      staticClass: "narrow-picker",
      attrs: {
        "picker-options": {
          start: '00:00',
          step: '00:15',
          end: '23:45'
        },
        "placeholder": "Closing time",
        "disabled": !_vm.$root.permissions['stores hours update'] ? true : false
      },
      model: {
        value: (hour.close_time),
        callback: function($$v) {
          _vm.$set(hour, "close_time", $$v)
        },
        expression: "hour.close_time"
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-icon-only btn-outline blue",
      attrs: {
        "data-toggle": "tooltip",
        "title": "Copy to all"
      },
      on: {
        "click": function($event) {
          _vm.applyClosingTimeToAll(hour.close_time, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-clone",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('el-switch', {
      attrs: {
        "active-color": "#0c6",
        "inactive-color": "#ff4949",
        "disabled": !_vm.$root.permissions['stores hours update'] ? true : false,
        "active-value": 1,
        "inactive-value": 0,
        "active-text": "Open",
        "inactive-text": "Closed"
      },
      model: {
        value: (hour.open),
        callback: function($$v) {
          _vm.$set(hour, "open", $$v)
        },
        expression: "hour.open"
      }
    })], 1)])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder clear"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit",
      "disabled": !_vm.$root.permissions['stores hours update'] ? true : false
    }
  }, [_vm._v("\n                      Save\n                    ")])])])]) : _vm._e(), _vm._v(" "), (_vm.noHoursData.length) ? _c('div', [_c('no-results', {
    attrs: {
      "show": _vm.noHoursData.length,
      "type": 'store profile',
      "custom": true,
      "text": _vm.noHoursData
    }
  })], 1) : _vm._e()])])])]), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Store Holiday Hours"
    }
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "portlet light bordered"
  }, [_c('div', {
    staticClass: "portlet-body form"
  }, [_c('div', {
    staticClass: "margin-bottom-20"
  }, [_c('button', {
    staticClass: "btn create-or-edit",
    class: {
      'blue': _vm.addAHoliday, 'blue btn-outline': !_vm.addAHoliday
    },
    attrs: {
      "disabled": !_vm.$root.permissions['stores holiday_hours update'] ? true : false
    },
    on: {
      "click": _vm.flipAddCreateHoliday
    }
  }, [_vm._v("\n                Add a holiday\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: {
      'blue': !_vm.addAHoliday, 'blue btn-outline': _vm.addAHoliday
    },
    attrs: {
      "disabled": !_vm.$root.permissions['stores holiday_hours update'] ? true : false
    },
    on: {
      "click": _vm.flipAddCreateHoliday
    }
  }, [_vm._v("\n                Edit a holiday\n              ")])]), _vm._v(" "), (_vm.addAHoliday) ? _c('add-holiday-hours', {
    attrs: {
      "selectedLocationId": parseInt(_vm.$route.params.store_id)
    },
    on: {
      "closeHolidayHoursModal": function($event) {
        _vm.showHolidayHoursModal = false
      },
      "addHolidayHours": _vm.addHolidayHours
    }
  }) : _c('div', {
    staticClass: "margin-top-20"
  }, [(_vm.updateHolidayHoursError.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError('updateHolidayHoursError')
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.updateHolidayHoursError))])]) : _vm._e(), _vm._v(" "), (_vm.holidayHoursToBeEdited.length) ? _c('div', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(" Holiday ")]), _vm._v(" "), _c('th', [_vm._v(" Day ")]), _vm._v(" "), _c('th', [_vm._v(" Start date ")]), _vm._v(" "), _c('th', [_vm._v(" End date ")]), _vm._v(" "), _c('th', [_vm._v(" Opening Time ")]), _vm._v(" "), _c('th', [_vm._v(" Closing Time ")]), _vm._v(" "), _c('th', [_vm._v(" Status ")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.holidayHoursToBeEdited), function(hour) {
    return _c('tr', {
      key: hour.id
    }, [_c('td', {
      staticClass: "align-middle"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hour.name),
        expression: "hour.name"
      }],
      staticClass: "form-control input-sm",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (hour.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(hour, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), (hour.day === 0) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Sun ")]) : _vm._e(), _vm._v(" "), (hour.day === 1) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Mon ")]) : _vm._e(), _vm._v(" "), (hour.day === 2) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Tue ")]) : _vm._e(), _vm._v(" "), (hour.day === 3) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Wed ")]) : _vm._e(), _vm._v(" "), (hour.day === 4) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Thu ")]) : _vm._e(), _vm._v(" "), (hour.day === 5) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Fri ")]) : _vm._e(), _vm._v(" "), (hour.day === 6) ? _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" Sat ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('el-date-picker', {
      staticClass: "narrow-date-picker",
      attrs: {
        "type": "date",
        "placeholder": "Start date",
        "format": "yyyy-MM-dd",
        "value-format": "yyyy-MM-dd",
        "clearable": false,
        "size": "small",
        "disabled": !_vm.$root.permissions['stores holiday_hours update'] ? true : false
      },
      model: {
        value: (hour.start_date),
        callback: function($$v) {
          _vm.$set(hour, "start_date", $$v)
        },
        expression: "hour.start_date"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('el-date-picker', {
      staticClass: "narrow-date-picker",
      attrs: {
        "type": "date",
        "placeholder": "End date",
        "format": "yyyy-MM-dd",
        "value-format": "yyyy-MM-dd",
        "clearable": false,
        "size": "small",
        "disabled": !_vm.$root.permissions['stores holiday_hours update'] ? true : false
      },
      model: {
        value: (hour.end_date),
        callback: function($$v) {
          _vm.$set(hour, "end_date", $$v)
        },
        expression: "hour.end_date"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('el-time-select', {
      staticClass: "narrow-time-picker",
      attrs: {
        "disabled": !_vm.$root.permissions['stores holiday_hours update'] ? true : false,
        "picker-options": {
          start: '00:00',
          step: '00:15',
          end: '23:45'
        },
        "clearable": false,
        "placeholder": "Set store opening time",
        "size": "small"
      },
      model: {
        value: (hour.open_time),
        callback: function($$v) {
          _vm.$set(hour, "open_time", $$v)
        },
        expression: "hour.open_time"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('el-time-select', {
      staticClass: "narrow-time-picker",
      attrs: {
        "picker-options": {
          start: '00:00',
          step: '00:15',
          end: '23:45'
        },
        "clearable": false,
        "placeholder": "Set store closing time",
        "size": "small",
        "disabled": !_vm.$root.permissions['stores holiday_hours update'] ? true : false
      },
      model: {
        value: (hour.close_time),
        callback: function($$v) {
          _vm.$set(hour, "close_time", $$v)
        },
        expression: "hour.close_time"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('el-switch', {
      attrs: {
        "active-color": "#0c6",
        "inactive-color": "#ff4949",
        "active-value": 1,
        "inactive-value": 0,
        "active-text": "Open",
        "inactive-text": "Closed",
        "disabled": !_vm.$root.permissions['stores holiday_hours update'] ? true : false
      },
      model: {
        value: (hour.open),
        callback: function($$v) {
          _vm.$set(hour, "open", $$v)
        },
        expression: "hour.open"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "loading": hour.loading,
        "disabled": hour.loading || !_vm.$root.permissions['stores holiday_hours update'] ? true : false,
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.updateHolidayHours(hour, $event)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!hour.loading),
        expression: "!hour.loading"
      }]
    }, [_vm._v("Save")])])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "loading": hour.loading,
        "disabled": hour.loading || !_vm.$root.permissions['stores holiday_hours update'] ? true : false,
        "size": "small",
        "plain": ""
      },
      on: {
        "click": function($event) {
          _vm.openDeleteHolidayHoursModal(hour)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!hour.loading),
        expression: "!hour.loading"
      }]
    }, [_vm._v("Delete")])])], 1)])
  }))])]) : _c('div', [_c('no-results', {
    attrs: {
      "show": !_vm.holidayHoursToBeEdited.length,
      "type": 'holiday hours',
      "custom": true,
      "text": _vm.customText
    }
  })], 1)])], 1)])])]), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Store Images"
    }
  }, [_c('div', {
    staticClass: "tab-content"
  }, [(_vm.storeToBeEdited.id !== undefined) ? _c('store-images', {
    attrs: {
      "storeId": _vm.storeToBeEdited.id
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.showDeleteHolidayHoursModal,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": _vm.closeDeleteHolidayHoursModal
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeDeleteHolidayHoursModal()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Delete Holiday Hours")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deleteHolidayHoursErrorMessage.length),
      expression: "deleteHolidayHoursErrorMessage.length"
    }],
    ref: "deleteHolidayHoursErrorMessage",
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearDeleteHolidayHoursError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.deleteHolidayHoursErrorMessage))])]), _vm._v(" "), _c('p', [_vm._v("Are you sure you want to delete these holiday hours?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.deleteHolidayHours()
      }
    }
  }, [_vm._v("Delete")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note note-info"
  }, [_c('p', [_vm._v("Update the general details, customs and hours of operation for a store.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7e9bfd8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/StoreManager/EditStore.vue
// module id = 788
// module chunks = 0